/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable xss/no-mixed-html */

PHI.autocomplete = {

  searchButton: null,

  searchField: null,

  searchBarEnabled: false,


  bindAll: function() {
    /* eslint-disable dollar-sign/dollar-sign */

    this.searchButton = $('#searchIcon');


    this.searchField = $('#search');


    /* eslint-enable dollar-sign/dollar-sign */

    this.bindSearchIcon();

    this.bindSearchInput();

    this.bindAutocomplete();
  },

  bindSearchInput: function() {
    // Hide input field whenever the search field is blurred

    this.searchField.on('focusout', function() {
      $(this).parents('li').removeClass('open');

      $('#profileName').removeClass('hide');
    });
  },


  /* The fly out functionality is already covered in the phi.categorynavigation.js,

    However we need to control some additional things here */

  bindSearchIcon: function() {
    $('#searchMenu').on('mouseover', function() {
      this.searchField.focus();

      $('#profileName').addClass('hide');
    }.bind(this));
  },
  bindAutocomplete: function() { // NOSONAR
    var option = PHI.autocomplete.searchField.data('options');
    var cache = {};

    if (option) {
      /* eslint-disable no-underscore-dangle */

      PHI.autocomplete.searchField.autocomplete({

        minLength: option.minCharactersBeforeRequest,

        delay: option.waitTimeBeforeRequest,

        appendTo: '.siteSearch',

        /* eslint-enable no-underscore-dangle */

        /* eslint-disable consistent-return */

        source: function(request, response) {
          var term = request.term.toLowerCase();

          if (term in cache) {
            return response(cache[term]);
          }

          $.getJSON(option.autocompleteUrl, {
            term: request.term
          })
            .done(function(data) {
              var autoSearchData = [];

              if (data.suggestions !== null) {
                $.each(data.suggestions, function(indx, obj) {
                  autoSearchData.push({

                    value: obj.term,

                    url: ACC.config.encodedContextPath + '/search?text=' + obj.term,

                    type: 'autoSuggestion'

                  });
                });
              }


              if (data.products !== null) {
                $.each(data.products, function(indx, obj) {
                  // Small fixes, otherwise it breaks when the result does not have prices or images

                  /* eslint-disable no-ternary */

                  var image = obj.images ? obj.images[0].url : null;
                  var price = obj.price ? obj.price.formattedValue : null;

                  /* eslint-enable no-ternary */

                  autoSearchData.push({

                    value: obj.name,
                    code: obj.code,
                    desc: obj.description,
                    manufacturer: obj.manufacturer,
                    url: ACC.config.encodedContextPath + obj.url,
                    imagePath: obj.imageURL,
                    prodDesc: obj.descriptor,
                    prodFamily: obj.familyName,
                    prodDisplayName: obj.displayName,
                    prodctv: obj.ctv,
                    prodEan: obj.sapEan,
                    price: price,
                    type: 'productResult',
                    image: image
                  });
                });
              }

              cache[term] = autoSearchData;

              return response(autoSearchData);
            }).fail(function() {
              // Jqxhr, textStatus, error - Console.log('Request Failed: ' + textStatus + ', ' + error);

              return false;
            });
        },
        focus: function() {
          return false;
        },

        select: function(event, usri) {
          var showText = $('ui-helper-hidden-accessible').html(),

              /* eslint-disable xss/no-location-href-assign */
              $modifiedTxt = $($.parseHTML(showText));

          $('ui-helper-hidden-accessible').innerHTML($modifiedTxt);
          window.location.href = usri.item.url;
          /* eslint-enable xss/no-location-href-assign */
        }

      }).autocomplete('instance')._renderItem = function(usrl, item) { // NOSONAR
        var renderHtml = '',
            suggestedHighlightText = '';

        /* eslint-disable id-length*/
        usrl.id = 'autoSuggest';
        usrl.addClass('p-search');

        /* eslint-enable id-length */
        /* eslint-enable consistent-return */

        if (item.type === 'autoSuggestion') {
          suggestedHighlightText = String(item.value).replace(new RegExp(this.term, 'gi'), '<b>$&</b>');
          renderHtml = '<a href=\'' + item.url + '\' class=\'clearfix\'>' + suggestedHighlightText + '</a>';

          return $('<li class="suggestions ph-suggest-item">')
            .data('item.autocomplete', item)
            .append(renderHtml)
            .appendTo(usrl);
        }

        $('ul.ui-autocomplete li.ph-suggest-item:last').addClass('ph-border');

        function addProdInfo(proditem) {
          var displayName = '',
              highlightCode = '',
              highlightEan = '',
              hiddenEanVal = '';

          displayName = proditem.prodctv + ' ' + proditem.prodDisplayName;
          displayName = String(displayName).replace(new RegExp(proditem.term, 'gi'), '<b>$&</b>');
          highlightCode = String(proditem.code).replace(new RegExp(proditem.term, 'gi'), '<b>$&</b>');
          highlightEan = String(proditem.prodEan).replace(new RegExp(proditem.term, 'gi'), '<b>$&</b>');

          if (proditem.prodEan.length > 0) {
            hiddenEanVal = '<span class="ph-search-ctv">EAN</span>' +
            '<span class="ph-value-ctv">: ' + highlightEan + '</span>';
          }

          if (proditem.prodDesc === null || proditem.prodFamily === null) {
            renderHtml = renderHtml + (
              '<div class=\'ph-search-img\'><img src=\'' + proditem.imagePath + '&wid=90&hei=90&$jpgsmall$ \'></div>' +
              '<div class=\'ph-right-cont\'>' +
              '<div class="ph-prod-details" style="-webkit-box-orient: vertical;"><span class="ph-class-desc">' + displayName + '</span>' +
              '</div>' +
              '<div class="ph-ctv-details"><span class="ph-search-NC">12NC</span><span class="ph-value-NC">: ' + highlightCode + '</span>' +
              '</br>' +
              hiddenEanVal +
              '</div></div></a>');
          } else {
            renderHtml = renderHtml + (
              '<div class=\'ph-search-img\'><img src=\'' + proditem.imagePath + '&wid=90&hei=90&$jpgsmall$ \'></div>' +
              '<div class=\'ph-right-cont\'>' +
              '<div class="ph-prod-details" style="-webkit-box-orient: vertical;">' +
              '<span class="ph-class-desc">' + displayName + '</span>' +
              '</br>' +
              '</div>' +
              '<div class="ph-ctv-details"><span class="ph-search-NC">12NC</span><span class="ph-value-NC">: ' + highlightCode + '</span></br>' +
              hiddenEanVal +
              '</div></div></a>');
          }
        }

        if (item.type === 'productResult') {
          renderHtml = '<a href=\'' + item.url + '\' class=\'ph-searchprodurl\'>';

          if (option.displayProductImages && item.image !== null) {
            renderHtml = renderHtml + '<span class=\'thumb\'></span>';
          }

          item.term = this.term;
          addProdInfo(item);

          return $('<li class="ph-item-details">').data('item.autocomplete', item).append(renderHtml).appendTo(usrl);
        }
      };
    }
  }

};

$(document).ready(function() {
  var appendSearch = '';

  if ($(window).width() < 960) {
    appendSearch = $('.ph-headerparent__primarysearchwrapper').detach();
    $('.ph-append_searchbar').append(appendSearch);
  }

  PHI.autocomplete.bindAll();
});

/* eslint-enable xss/no-mixed-html */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
